/* eslint-disable react/no-unescaped-entities */
import React from 'react'
import './FairPlay.scss'

const FairPlay = () => {
  return (
    <div className="fair-container">
      <div className="WordSection1">
        <p className="MsoTitle">
          <a name="_kt8fcwdp6bxv" />
          <span lang="EN">Fair Play Policy</span>
        </p>
        <p className="MsoNormal">
          <span lang="EN" style={{ fontSize: '10.5pt', lineHeight: '115%', color: '#312E2B' }}>
            Effective date: October 27, 2022
          </span>
        </p>
        <p className="MsoNormal" style={{ marginBottom: '.25in', lineHeight: '150%' }}>
          <span lang="EN" style={{ fontSize: '10.5pt', lineHeight: '150%', color: '#312E2B' }}>
            ChessX has a responsibility to maintain a clean, fair platform for chess players around
            the world. We reserve the right to monitor all chess games played on our platform. We
            reserve the right to modify this policy at any time without notice to you. Please see
            our User Agreement for more information regarding the applicability and enforcement of
            the Fair Play Policy.
          </span>
        </p>
        <p className="MsoNormal" style={{ marginLeft: '.5in', textIndent: '-.25in' }}>
          <span lang="EN" style={{ fontSize: '10.5pt', lineHeight: '115%', color: '#312E2B' }}>
            ●
            <span style={{ font: '7.0pt "Times New Roman"' }}>
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{' '}
            </span>
          </span>
          <span lang="EN" style={{ fontSize: '10.5pt', lineHeight: '115%', color: '#312E2B' }}>
            All of your moves must be your own
          </span>
        </p>
        <p className="MsoNormal" style={{ marginLeft: '.5in', textIndent: '-.25in' }}>
          <span lang="EN" style={{ fontSize: '10.5pt', lineHeight: '115%', color: '#312E2B' }}>
            ●
            <span style={{ font: '7.0pt "Times New Roman"' }}>
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{' '}
            </span>
          </span>
          <span lang="EN" style={{ fontSize: '10.5pt', lineHeight: '115%', color: '#312E2B' }}>
            Do not cheat in any way
          </span>
        </p>
        <p className="MsoNormal" style={{ marginLeft: '.5in', textIndent: '-.25in' }}>
          <span lang="EN" style={{ fontSize: '10.5pt', lineHeight: '115%', color: '#312E2B' }}>
            ●
            <span style={{ font: '7.0pt "Times New Roman"' }}>
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{' '}
            </span>
          </span>
          <span lang="EN" style={{ fontSize: '10.5pt', lineHeight: '115%', color: '#312E2B' }}>
            Do not get help from any other person, including parents, friends, coaches or another
            player
          </span>
        </p>
        <p className="MsoNormal" style={{ marginLeft: '.5in', textIndent: '-.25in' }}>
          <span lang="EN" style={{ fontSize: '10.5pt', lineHeight: '115%', color: '#312E2B' }}>
            ●
            <span style={{ font: '7.0pt "Times New Roman"' }}>
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{' '}
            </span>
          </span>
          <span lang="EN" style={{ fontSize: '10.5pt', lineHeight: '115%', color: '#312E2B' }}>
            Do not use chess engines, software of any kind, bots, plugins or any tools that analyze
            positions during play
          </span>
        </p>
        <p className="MsoNormal" style={{ marginLeft: '.5in', textIndent: '-.25in' }}>
          <span lang="EN" style={{ fontSize: '10.5pt', lineHeight: '115%', color: '#312E2B' }}>
            ●
            <span style={{ font: '7.0pt "Times New Roman"' }}>
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{' '}
            </span>
          </span>
          <span lang="EN" style={{ fontSize: '10.5pt', lineHeight: '115%', color: '#312E2B' }}>
            Do not use tablebases or any other resources that show the best move (in both Online and
            Daily chess)
          </span>
        </p>
        <p className="MsoNormal" style={{ marginLeft: '.5in', textIndent: '-.25in' }}>
          <span lang="EN" style={{ fontSize: '10.5pt', lineHeight: '115%', color: '#312E2B' }}>
            ●
            <span style={{ font: '7.0pt "Times New Roman"' }}>
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{' '}
            </span>
          </span>
          <span lang="EN" style={{ fontSize: '10.5pt', lineHeight: '115%', color: '#312E2B' }}>
            You may use Opening Explorer or other books without engine evaluations in Daily chess
            only (not in Online / Live play)
          </span>
        </p>
        <p className="MsoNormal" style={{ marginLeft: '.5in', textIndent: '-.25in' }}>
          <span lang="EN" style={{ fontSize: '10.5pt', lineHeight: '115%', color: '#312E2B' }}>
            ●
            <span style={{ font: '7.0pt "Times New Roman"' }}>
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{' '}
            </span>
          </span>
          <span lang="EN" style={{ fontSize: '10.5pt', lineHeight: '115%', color: '#312E2B' }}>
            Do not perform any automated analysis or &quot;blunder checking&quot; of your games in
            progress
          </span>
        </p>
        <p className="MsoNormal" style={{ marginLeft: '.5in', textIndent: '-.25in' }}>
          <span lang="EN" style={{ fontSize: '10.5pt', lineHeight: '115%', color: '#312E2B' }}>
            ●
            <span style={{ font: '7.0pt "Times New Roman"' }}>
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{' '}
            </span>
          </span>
          <span lang="EN" style={{ fontSize: '10.5pt', lineHeight: '115%', color: '#312E2B' }}>
            Do not allow anyone else to use your account
          </span>
        </p>
        <p className="MsoNormal" style={{ marginLeft: '.5in', textIndent: '-.25in' }}>
          <span lang="EN" style={{ fontSize: '10.5pt', lineHeight: '115%', color: '#312E2B' }}>
            ●
            <span style={{ font: '7.0pt "Times New Roman"' }}>
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{' '}
            </span>
          </span>
          <span lang="EN" style={{ fontSize: '10.5pt', lineHeight: '115%', color: '#312E2B' }}>
            Do not use anyone else's account
          </span>
        </p>
        <p className="MsoNormal" style={{ marginLeft: '.5in', textIndent: '-.25in' }}>
          <span lang="EN" style={{ fontSize: '10.5pt', lineHeight: '115%', color: '#312E2B' }}>
            ●
            <span style={{ font: '7.0pt "Times New Roman"' }}>
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{' '}
            </span>
          </span>
          <span lang="EN" style={{ fontSize: '10.5pt', lineHeight: '115%', color: '#312E2B' }}>
            Do not artificially manipulate ratings, matches, or game outcomes
          </span>
        </p>
        <p className="MsoNormal" style={{ marginLeft: '.5in', textIndent: '-.25in' }}>
          <span lang="EN" style={{ fontSize: '10.5pt', lineHeight: '115%', color: '#312E2B' }}>
            ●
            <span style={{ font: '7.0pt "Times New Roman"' }}>
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{' '}
            </span>
          </span>
          <span lang="EN" style={{ fontSize: '10.5pt', lineHeight: '115%', color: '#312E2B' }}>
            Do not interfere with the gameplay of other members
          </span>
        </p>
        <p
          className="MsoNormal"
          style={{
            marginTop: '0in',
            marginRight: '0in',
            marginBottom: '.25in',
            marginLeft: '.5in',
            textIndent: '-.25in'
          }}
        >
          <span lang="EN" style={{ fontSize: '10.5pt', lineHeight: '115%', color: '#312E2B' }}>
            ●
            <span style={{ font: '7.0pt "Times New Roman"' }}>
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
            </span>
          </span>
          <span lang="EN" style={{ fontSize: '10.5pt', lineHeight: '115%', color: '#312E2B' }}>
            Suspecting your opponent of using outside help is not an excuse to do the same. If you
            suspect someone is cheating, report the player to ChessX.
          </span>
        </p>
        <p
          className="MsoNormal"
          style={{
            marginTop: '.5in',
            marginRight: '0in',
            marginBottom: '.25in',
            marginLeft: '0in',
            lineHeight: '150%'
          }}
        >
          <b>
            <span lang="EN" style={{ fontSize: '10.5pt', lineHeight: '150%', color: '#312E2B' }}>
              EXCEPTION:
            </span>
          </b>
          <span lang="EN" style={{ fontSize: '10.5pt', lineHeight: '150%', color: '#312E2B' }}>
            {' '}
            These rules do not apply to unrated games or tactics. However, if you intend to use
            assistance against your opponent, you must notify them beforehand. We may expand or
            narrow any applicable exceptions to the Fair Play Policy at any time without notice to
            you.
          </span>
        </p>
        <p className="MsoNormal" style={{ marginBottom: '.25in', lineHeight: '150%' }}>
          <b>
            <span lang="EN" style={{ fontSize: '10.5pt', lineHeight: '150%', color: '#312E2B' }}>
              WARNING:
            </span>
          </b>
          <span lang="EN" style={{ fontSize: '10.5pt', lineHeight: '150%', color: '#312E2B' }}>
            {' '}
            If we determine that you have violated our Fair Play Policy, then we will close your
            account and label it closed for a Fair Play violation. All account status changes are
            made in our sole discretion. For a full listing of the measures we will take to both
            monitor your play on ChessX and enforce our Fair Play Policy, see the Termination and
            Account Limitations sections of our User Agreement.
          </span>
        </p>
        <p className="MsoNormal">
          <span lang="EN">&nbsp;</span>
        </p>
      </div>
    </div>
  )
}

export default FairPlay
